import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { TrackingPickup } from '@tracking/const';
import { StateWithTracking } from '../tracking-state';
import { getTrackingState } from './feature.selector';

export const getTrackingPickupDetailState: MemoizedSelector<
  StateWithTracking,
  StateUtils.EntityLoaderState<TrackingPickup>
> = createSelector(getTrackingState, (state) => state.trackingPickup);

export const getTrackingPickup = (
  orderGuid: string,
): MemoizedSelector<StateWithTracking, StateUtils.LoaderState<TrackingPickup>> =>
  createSelector(getTrackingPickupDetailState, (state) => StateUtils.entityLoaderStateSelector(state, orderGuid));

export const getTrackingPickupValue = (orderGuid: string): MemoizedSelector<StateWithTracking, TrackingPickup> =>
  createSelector(getTrackingPickupDetailState, (state) => StateUtils.entityValueSelector(state, orderGuid));

export const getTrackingPickupLoading = (orderGuid: string): MemoizedSelector<StateWithTracking, boolean> =>
  createSelector(getTrackingPickupDetailState, (state) => StateUtils.entityLoadingSelector(state, orderGuid));

export const getTrackingPickupError = (orderGuid: string): MemoizedSelector<StateWithTracking, boolean> =>
  createSelector(getTrackingPickupDetailState, (state) => StateUtils.entityErrorSelector(state, orderGuid));

export const getTrackingPickupSuccess = (orderGuid: string): MemoizedSelector<StateWithTracking, boolean> =>
  createSelector(getTrackingPickupDetailState, (state) => StateUtils.entitySuccessSelector(state, orderGuid));
